module.exports = __webpack_public_path__ + "img/toutou_song_2.793e83c6.jpg";